import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Div } from '../../../layouts';
import { CurrentSearch } from '../../../redux/currentSearch/actionTypes';
import { SlideGroupContext } from '../../../components/SlideManager';
import { ExtraBottomPadding } from './ExtraBottomPadding';
import { CMS } from '../../../utils/CMS';
import { FieldType, FieldTypeProps } from '../../../models';
import {
    getNonPrimeHotelRoom,
    hasAgeKidsErrors,
} from '../../../redux/currentSearch/selectors';
import { showRoomErrors } from '../../../redux/currentSearch/actions';
import { ABUtils } from '../../../utils';

const style = {
    width: '100%',
    marginTop: 1,
};

const NextButton = ({ extraTracking, dispatch, hasErrorValidation, showErrorValidation, loading, fullWidth, testId }) => {
    const { isCssVariationMobile } = ABUtils.getABs();
    const { next } = React.useContext(SlideGroupContext);
    const [isLoading, setIsLoading] = React.useState(loading);

    const onClickContinue = () => {
        if (hasErrorValidation) {
            showErrorValidation();
        } else {
            setIsLoading(true);
            showErrorValidation(false);
            extraTracking();
            dispatch({ type: CurrentSearch.HANDLE_PRE_SEARCH });
            next();
        }
    };

    const isLoadingButtonStatus = isCssVariationMobile && isLoading;

    const buttonClassName = classNames({
        'odf-btn odf-btn-primary': !isCssVariationMobile,
        'prisma-btn prisma-btn-highlight prisma-btn-round prisma-btn-loading': isCssVariationMobile,
        'loading': isLoadingButtonStatus,
    });
    const wrapperClassName = classNames({
        'odf-space-inner-s safari-extra-padding-bottom': !isCssVariationMobile,
        'prisma-responsive-space-horizontal odf-space-inner-top-m odf-space-inner-bottom-m safari-extra-padding-bottom-lg': isCssVariationMobile,
        'prisma-elevation-1': fullWidth && isCssVariationMobile,
    });

    return (
        <ExtraBottomPadding>
            <Div {...style}>
                <Div className={wrapperClassName}>
                    <div className="odf-flex-container-row odf-flex-container-justify-end">
                        <div className="odf-flex-item odf-flex-item-sm">
                            <button type="button" className={buttonClassName} onClick={onClickContinue} test-id={testId}>
                                <div><CMS id="flightsManager.selection.continue" /></div>
                                {isLoadingButtonStatus && (
                                    <span className="prisma-btn-spinner">
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>
                </Div>
            </Div>
        </ExtraBottomPadding>
    );
};

NextButton.propTypes = {
    extraTracking: PropTypes.func,
    dispatch: PropTypes.func,
    hasErrorValidation: PropTypes.bool,
    showErrorValidation: PropTypes.func,
    loading: PropTypes.bool,
    fullWidth: PropTypes.bool,
    testId: PropTypes.string,
};

NextButton.defaultProps = {
    extraTracking: () => {},
    dispatch: () => {},
    hasErrorValidation: false,
    showErrorValidation: () => {},
    loading: false,
    fullWidth: true,
    testId: 'next-btn',
};

const ConnectedNextButton = connect(null)(NextButton);

export { ConnectedNextButton as NextButton };

const withValidationError = (Child) => {
    const Inner = ({ type, hasAgeKidsErrors, showRoomErrors, nonPrimeHotelRooms, ...props }) => {
        let validation = {};
        const nonPrimeHotelRoomAgeError = nonPrimeHotelRooms.kids.some((kidAge) => kidAge === -1);
        if (type === FieldType.ROOM) {
            validation = { hasErrorValidation: hasAgeKidsErrors || nonPrimeHotelRoomAgeError, showErrorValidation: showRoomErrors };
        }
        return <Child {...validation} {...props} />;
    };
    Inner.propTypes = {
        type: FieldTypeProps.isRequired,
        hasAgeKidsErrors: PropTypes.bool.isRequired,
        nonPrimeHotelRooms: PropTypes.object.isRequired,
        showRoomErrors: PropTypes.func.isRequired,
    };
    return Inner;
};

const mapStateToPropsSelector = createStructuredSelector({
    hasAgeKidsErrors: hasAgeKidsErrors,
    nonPrimeHotelRooms: getNonPrimeHotelRoom,
});

export const NextButtonWithValidation = connect(mapStateToPropsSelector, {
    showRoomErrors,
})(withValidationError(NextButton));
